import usePlatform from './platformAtom';

export * from './platformAtom';

export default usePlatform;
